module.exports = __webpack_public_path__ + "img/B - 03.2e65913c.png";